var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchIconGrey = function SvgSearchIconGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1444 14L8.03056 8.88611C7.64167 9.22315 7.18823 9.48565 6.67024 9.67361C6.15225 9.86157 5.60106 9.95556 5.01667 9.95556C3.61457 9.95556 2.42793 9.46944 1.45676 8.49722C0.485586 7.525 0 6.35185 0 4.97778C0 3.6037 0.486111 2.43056 1.45833 1.45833C2.43056 0.486111 3.60694 0 4.9875 0C6.36806 0 7.5412 0.486111 8.50694 1.45833C9.47268 2.43056 9.95556 3.60468 9.95556 4.9807C9.95556 5.53616 9.86481 6.07315 9.68333 6.59167C9.50185 7.11019 9.22963 7.5963 8.86667 8.05L14 13.1444L13.1444 14ZM4.99722 8.78889C6.05046 8.78889 6.94572 8.4162 7.68299 7.67083C8.42025 6.92546 8.78889 6.02778 8.78889 4.97778C8.78889 3.92778 8.42025 3.03009 7.68299 2.28472C6.94572 1.53935 6.05046 1.16667 4.99722 1.16667C3.93318 1.16667 3.02874 1.53935 2.28391 2.28472C1.53908 3.03009 1.16667 3.92778 1.16667 4.97778C1.16667 6.02778 1.53908 6.92546 2.28391 7.67083C3.02874 8.4162 3.93318 8.78889 4.99722 8.78889Z",
    fill: "#666666"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIconGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/searchIconGrey.e84eef85.svg";
export { ForwardRef as ReactComponent };